import { createFrontendLogger } from '@template-project/storefront-shared';

export const storefrontLayoutLogger = createFrontendLogger('storefront-layout');
